// replace("Hello {0}! Welcome to {1}.", ['foo', 'bar'])
//  => Hello foo! Welcome to bar.
const replace = (string: string, replaces: (string | number)[]): string =>
  string.replace(/{(\d+)}/g, (match, index) =>
    typeof replaces[Number(index)] !== 'undefined' ? String(replaces[Number(index)]) : match,
  )

export default replace
